













































































































import Vue from 'vue'
import { mapState } from 'vuex'
import _ from 'lodash'

export default Vue.extend({
  props: {
    'filter': {
      default: null,
      type: Object,
    },
  },
  computed: mapState({
    industries: (state: any) => state.industries.items,
    categories: (state: any) => state.categories.items,
    levels: (state: any) => state.levels.items,
    countries: (state: any) => state.countries.items,
    regions: (state: any) => state.regions.items,
    districts: (state: any) => state.districts.items,
    cities: (state: any) => state.cities.items,
  }),
  methods: {
    onFilterChange: _.debounce(function(this: any) {
      this.$emit('input', _.omitBy(this.filter, _.isNull))
    }, 250),
  },
})
